import { getAxiosInstance } from '@project/utils/request';
import {
  FieldOption,
  StatisticDataItem,
} from '@project/components/Module/StatisticMenu/types';

export class APIStatistics {
  readonly url = '/api/statistics/';

  async getTableTypes(tableName: string): Promise<FieldOption[]> {
    return await getAxiosInstance().get(
      this.url + 'get_table_types/' + tableName,
    );
  }

  async getTableData({
    tableName,
    fields = [],
    page = 1,
    pageSize = 0,
  }: {
    tableName: string;
    fields?: { name: string; value: string | number }[];
    page?: number;
    pageSize?: number;
  }): Promise<StatisticDataItem[]> {
    const response = await getAxiosInstance().get(
      this.url + 'get_table_statistics/',
      {
        params: {
          table_name: tableName,
          fields: fields.length
            ? fields.map(({ name }) => name).join(',')
            : undefined,
          values: fields.length
            ? fields.map(({ value }) => value).join(',')
            : undefined,
          _page_size: pageSize,
          _page: pageSize ? page : undefined,
        },
      },
    );

    return response.results;
  }
}
